export const TOGGLE_OPEN = 'NAVIGATION_TOGGLE_OPEN';
export const SET_FLOATING = 'NAVIGATTON_SET_FLOATING';

interface ToggleOpenAction {
    type: typeof TOGGLE_OPEN,
    payload: boolean
}

interface SetFloatingAction {
    type: typeof SET_FLOATING,
    payload: boolean
}

export type NavigationActionTypes =
    ToggleOpenAction |
    SetFloatingAction;